module.exports = "/_next/static/images/8400765d54ed545907ccda618e2b11f1-open-graph-logo-large.jpg";